class CanDrag {
    constructor() {
        this.selector = '.can-drag';
        this.offset = 65;
        this.activeElement = null;
        this.cursor = null;
        this.enabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        if (!this.enabled) {
            return;
        }

        this.injectStyles();
        this.createCursor();
        this.bindEvents();
    }

    injectStyles() {
        if (document.getElementById('can-drag-cursor-styles')) {
            return;
        }

        const style = document.createElement('style');
        style.id = 'can-drag-cursor-styles';
        style.textContent = `
            .can-drag-cursor {
                position: fixed;
                top: 0;
                left: 0;
                width: 130px;
                height: 130px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 9999px;
                background: #123BCA;
                color: #FFFFFF;
                font-size: 20px;
                font-weight: 700;
                line-height: 1;
                letter-spacing: 0.12em;
                text-transform: uppercase;
                pointer-events: none;
                opacity: 0;
                visibility: hidden;
                transform: translate3d(-9999px, -9999px, 0);
                transition: opacity 0.2s ease, visibility 0.2s ease;
                z-index: 9999;
            }

            .can-drag-cursor.is-visible {
                opacity: 1;
                visibility: visible;
            }
        `;

        document.head.appendChild(style);
    }

    createCursor() {
        this.cursor = document.createElement('div');
        this.cursor.className = 'can-drag-cursor';
        this.cursor.textContent = 'DRAG';
        document.body.appendChild(this.cursor);
    }

    bindEvents() {
        document.addEventListener('pointermove', this.handlePointerMove, { passive: true });
        document.addEventListener('pointerleave', this.hideCursor);
        window.addEventListener('blur', this.hideCursor);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handlePointerMove = (event) => {
        const target = event.target.closest(this.selector);

        if (!target) {
            this.activeElement = null;
            this.hideCursor();
            return;
        }

        this.activeElement = target;
        this.moveCursor(event.clientX, event.clientY);
        this.showCursor();
    };

    handleVisibilityChange = () => {
        if (document.hidden) {
            this.hideCursor();
        }
    };

    moveCursor(x, y) {
        if (!this.cursor) {
            return;
        }

        this.cursor.style.transform = `translate3d(${x - this.offset}px, ${y - this.offset}px, 0)`;
    }

    showCursor() {
        if (!this.cursor) {
            return;
        }

        this.cursor.classList.add('is-visible');
    }

    hideCursor = () => {
        if (!this.cursor) {
            return;
        }

        this.cursor.classList.remove('is-visible');
    };
}

export { CanDrag as default };
